import React, { PropTypes } from 'react'
import { Link } from 'react-router'
import cx from 'classnames'

import './ProfileSidebarMenuItem.scss'

const ProfileSidebarMenuItem = ({ icon, to, label, className }) => {
  const itemClassName = cx(
    'ProfileSidebarMenuItem',
    {
      [className]: className
    }
  )
  const iconClassName = cx(
    'ProfileSidebarMenuItem-icon',
    {
      [`icon-${icon}`]: icon
    }
  )

  return (
    <Link to={to} className={itemClassName} activeClassName='ProfileSidebarMenuItem--active'>
      <span className={iconClassName} />
      <span className='ProfileSidebarMenuItem-label'>{label}</span>
    </Link>
  )
}

ProfileSidebarMenuItem.displayName = 'ProfileSidebarMenuItem'
ProfileSidebarMenuItem.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string,
  to: PropTypes.string,
  label: PropTypes.string
}
ProfileSidebarMenuItem.defaultProps = {}

export default ProfileSidebarMenuItem



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/components/ProfileSidebar/components/ProfileSidebarMenuItem/ProfileSidebarMenuItem.js